// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-branch-form {
  width: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.add-branch-form .branch-form-user-form {
  width: 100%;
  max-width: 500px;
  background: #fff;
  transition: all 0.3s ease-in-out;
}
.add-branch-form .branch-form-user-form h2 {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #1e1e1e;
  font-size: 1.3rem;
}
.add-branch-form .branch-form-user-form label {
  display: block;
  margin-bottom: 1.5rem;
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}
.add-branch-form .branch-form-user-form label input {
  width: 100%;
  margin-top: 0.4rem;
  padding: 0.75rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  box-sizing: border-box;
  transition: border 0.2s ease;
}
.add-branch-form .branch-form-user-form label input:focus {
  border-color: var(--primary-color);
  outline: none;
}
.add-branch-form .branch-form-user-form label .error {
  color: #e74c3c;
  font-size: 0.85rem;
  margin-top: 0.4rem;
  display: block;
}
.add-branch-form .branch-form-user-form .branch-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.add-branch-form .branch-form-user-form .branch-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.add-branch-form .branch-form-user-form .branch-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.add-branch-form .branch-form-user-form .button-group {
  display: flex;
  justify-content: end;
  gap: 0.5rem;
  margin-top: 1rem;
}
.add-branch-form .branch-form-user-form .button-group button {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}
.add-branch-form .branch-form-user-form .button-group button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.add-branch-form .branch-form-user-form .button-group .save-btn {
  background: var(--primary-color);
  color: white;
}
.add-branch-form .branch-form-user-form .button-group .save-btn:hover {
  background: var(--primary-color);
}
.add-branch-form .branch-form-user-form .button-group .cancel-btn {
  background: #6b7280;
  color: white;
}
.add-branch-form .branch-form-user-form .button-group .cancel-btn:hover {
  background: #4b5563;
}
.add-branch-form .branch-form-user-form .button-group .cancel-btn:active {
  background: #374151;
}
@media (max-width: 768px) {
  .add-branch-form .branch-form-user-form {
    padding: 1.5rem;
  }
  .add-branch-form .branch-form-user-form h2 {
    font-size: 1.5rem;
  }
  .add-branch-form .branch-form-user-form label {
    font-size: 0.95rem;
  }
  .add-branch-form .branch-form-user-form label input {
    font-size: 0.95rem;
  }
  .add-branch-form .branch-form-user-form label .error {
    font-size: 0.8rem;
  }
  .add-branch-form .branch-form-user-form .button-group button {
    font-size: 0.95rem;
  }
}
@media (max-width: 480px) {
  .add-branch-form .branch-form-user-form {
    padding: 1rem;
  }
  .add-branch-form .branch-form-user-form h2 {
    font-size: 1.3rem;
  }
  .add-branch-form .branch-form-user-form label {
    font-size: 0.9rem;
  }
  .add-branch-form .branch-form-user-form label input {
    font-size: 0.9rem;
    padding: 0.65rem;
  }
  .add-branch-form .branch-form-user-form label .error {
    font-size: 0.75rem;
  }
  .add-branch-form .branch-form-user-form .button-group {
    flex-direction: column;
  }
  .add-branch-form .branch-form-user-form .button-group button {
    width: 100%;
    font-size: 0.95rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/BranchForm/BranchForm.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;EACA,gBAAA;EAGA,gBAAA;EACA,gCAAA;AADJ;AAGI;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;AADN;AAII;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAFN;AAIM;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,sBAAA;EACA,4BAAA;AAFR;AAIQ;EACE,kCAAA;EACA,aAAA;AAFV;AAMM;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAJR;AAOI;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AALJ;AAOI;EACE,yBAAA;EACA,cAAA;AALN;AAQI;EACE,aAAA;EACA,6CAAA;AANN;AAUI;EACE,aAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AARN;AAUM;EAQE,iBAAA;EACJ,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAfJ;AAiBQ;EACE,YAAA;EACA,mBAAA;AAfV;AAmBM;EAYE,gCAAA;EACJ,YAAA;AA5BJ;AA8BI;EACE,gCAAA;AA5BN;AAgCM;EAoBA,mBAAA;EACF,YAAA;AAjDJ;AAmDI;EACE,mBAAA;AAjDN;AAoDI;EACE,mBAAA;AAlDN;AAwDI;EA7JF;IA8JI,eAAA;EArDJ;EAuDI;IACE,iBAAA;EArDN;EAwDI;IACE,kBAAA;EAtDN;EAwDM;IACE,kBAAA;EAtDR;EAyDM;IACE,iBAAA;EAvDR;EA4DM;IACE,kBAAA;EA1DR;AACF;AA+DI;EAxLF;IAyLI,aAAA;EA5DJ;EA8DI;IACE,iBAAA;EA5DN;EA+DI;IACE,iBAAA;EA7DN;EA+DM;IACE,iBAAA;IACA,gBAAA;EA7DR;EAgEM;IACE,kBAAA;EA9DR;EAkEI;IACE,sBAAA;EAhEN;EAkEM;IACE,WAAA;IACA,kBAAA;EAhER;AACF","sourcesContent":[".add-branch-form {\r\n  width: 450px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  .branch-form-user-form {\r\n    width: 100%;\r\n    max-width: 500px;\r\n    // margin: 2rem auto;\r\n    //padding: 1rem;\r\n    background: #fff;\r\n    transition: all 0.3s ease-in-out;\r\n\r\n    h2 {\r\n      text-align: center;\r\n      margin-bottom: 1.5rem;\r\n      color: #1e1e1e;\r\n      font-size: 1.3rem;\r\n    }\r\n\r\n    label {\r\n      display: block;\r\n      margin-bottom: 1.5rem;\r\n      font-weight: 600;\r\n      color: #333;\r\n      font-size: 1rem;\r\n\r\n      input {\r\n        width: 100%;\r\n        margin-top: 0.4rem;\r\n        padding: 0.75rem;\r\n        border-radius: 8px;\r\n        border: 1px solid #ccc;\r\n        font-size: 1rem;\r\n        box-sizing: border-box;\r\n        transition: border 0.2s ease;\r\n\r\n        &:focus {\r\n          border-color: var(--primary-color);\r\n          outline: none;\r\n        }\r\n      }\r\n\r\n      .error {\r\n        color: #e74c3c;\r\n        font-size: 0.85rem;\r\n        margin-top: 0.4rem;\r\n        display: block;\r\n      }\r\n    }\r\n    .branch-form-close-button {\r\n    position: absolute;\r\n    top: 1rem;\r\n    right: 1rem;\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    color: #6b7280;\r\n    cursor: pointer;\r\n    z-index: 1001;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 0.25rem;\r\n    transition: all 0.2s ease;\r\n\r\n    &:hover {\r\n      background-color: #f3f4f6;\r\n      color: #374151;\r\n    }\r\n\r\n    &:focus {\r\n      outline: none;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n\r\n    .button-group {\r\n      display: flex;\r\n      justify-content: end;\r\n      gap: 0.5rem;\r\n      margin-top: 1rem;\r\n\r\n      button {\r\n        // padding: 8px 18px;\r\n        // font-size: 1rem;\r\n        // border-radius: 8px;\r\n        // border: 1px solid #ddd;\r\n        // cursor: pointer;\r\n        // transition: all 0.3s ease;\r\n\r\n        padding: 8px 18px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    min-width: 80px;\r\n\r\n        &:disabled {\r\n          opacity: 0.5;\r\n          cursor: not-allowed;\r\n        }\r\n      }\r\n\r\n      .save-btn {\r\n        // background: var(--primary-color);\r\n        // color: white;\r\n\r\n        // &:hover:not(:disabled) {\r\n        //   background: var(--primary-color);\r\n        // }\r\n\r\n        // &:disabled {\r\n        //   background: #9ca3af;\r\n        //   color: #6b7280;\r\n        // }\r\n        background:var(--primary-color);\r\n    color: white;\r\n\r\n    &:hover {\r\n      background: var(--primary-color);\r\n    }\r\n      }\r\n\r\n      .cancel-btn {\r\n        //background: #666;\r\n        //color: white;\r\n\r\n        //background:var(--grey-shade-two);\r\n        //background: white;\r\n        //color: #666;\r\n\r\n        // &:hover:not(:disabled) {\r\n        //   background: #c82333;\r\n        // }\r\n\r\n      //   &:hover {\r\n      //   background-color: #f8f9fa;\r\n      // }\r\n\r\n      //   &:disabled {\r\n      //     background: #d1d5db;\r\n      //     color: #9ca3af;\r\n      //   }\r\n      background: #6b7280;\r\n    color: white;\r\n\r\n    &:hover {\r\n      background: #4b5563;\r\n    }\r\n\r\n    &:active {\r\n      background: #374151;\r\n    }\r\n      }\r\n    }\r\n\r\n    // Tablet responsiveness\r\n    @media (max-width: 768px) {\r\n      padding: 1.5rem;\r\n\r\n      h2 {\r\n        font-size: 1.5rem;\r\n      }\r\n\r\n      label {\r\n        font-size: 0.95rem;\r\n\r\n        input {\r\n          font-size: 0.95rem;\r\n        }\r\n\r\n        .error {\r\n          font-size: 0.8rem;\r\n        }\r\n      }\r\n\r\n      .button-group {\r\n        button {\r\n          font-size: 0.95rem;\r\n        }\r\n      }\r\n    }\r\n\r\n    // Mobile responsiveness\r\n    @media (max-width: 480px) {\r\n      padding: 1rem;\r\n\r\n      h2 {\r\n        font-size: 1.3rem;\r\n      }\r\n\r\n      label {\r\n        font-size: 0.9rem;\r\n\r\n        input {\r\n          font-size: 0.9rem;\r\n          padding: 0.65rem;\r\n        }\r\n\r\n        .error {\r\n          font-size: 0.75rem;\r\n        }\r\n      }\r\n\r\n      .button-group {\r\n        flex-direction: column;\r\n\r\n        button {\r\n          width: 100%;\r\n          font-size: 0.95rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
